<template>
    <div>
        <template v-if="unlocked">
            <div class="admin-access-bar"><button type="button" @click="lock">관리자 잠금</button></div>
            <Zone5Admin />
        </template>
        <main v-else class="admin-login">
            <router-link to="/" class="back-link">‹ 홈으로</router-link>
            <span class="eyebrow">ZONE5 ADMIN</span>
            <h1>관리자 로그인</h1>
            <p>관리자 비밀번호를 입력해 주세요.</p>
            <form @submit.prevent="unlock">
                <label for="admin-password">비밀번호</label>
                <input id="admin-password" ref="passwordInput" v-model="password" type="password" autocomplete="current-password" required :disabled="checking" :aria-invalid="!!error" aria-describedby="admin-login-error">
                <p id="admin-login-error" class="error" role="alert">{{ error }}</p>
                <button type="submit" :disabled="checking || !password">{{ checking ? '확인 중…' : '관리자 입장' }}</button>
            </form>
        </main>
    </div>
</template>

<script>
import Zone5Admin from './Zone5Admin.vue';

// A simple browser-side screen lock, as requested for this personal site.
// This does not replace database access rules or server authentication.
const PASSWORD_DIGEST = '7eb2b37dd0e5a0e978022982289be2e23a53f9d2b6bb8ee94c46920d17873f9f';

export default {
    components: { Zone5Admin },
    data() { return { unlocked: false, password: '', checking: false, error: '' }; },
    methods: {
        async unlock() {
            if (this.checking || !this.password) return;
            this.checking = true;
            this.error = '';
            try {
                const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(this.password));
                const actual = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
                if (actual === PASSWORD_DIGEST) this.unlocked = true;
                else this.error = '비밀번호가 올바르지 않습니다.';
            } catch (error) {
                this.error = '비밀번호를 확인하지 못했습니다. 페이지를 새로고침한 뒤 다시 시도해 주세요.';
            } finally {
                this.password = '';
                this.checking = false;
                if (!this.unlocked) this.$nextTick(() => this.$refs.passwordInput.focus());
            }
        },
        lock() { this.unlocked = false; this.password = ''; this.error = ''; }
    }
};
</script>

<style scoped>
.admin-login { max-width:420px; margin:0 auto; padding:28px 20px 60px; color:#172033; text-align:left; }
.back-link { display:block; width:fit-content; padding:12px 0; margin-bottom:20px; color:#475569; font-size:14px; text-decoration:none; }
.eyebrow { display:block; font-size:14px; font-weight:800; color:#2563eb; letter-spacing:1.5px; }
h1 { margin:12px 0; font-size:28px; font-weight:800; }
.admin-login > p { color:#475569; font-size:14px; line-height:1.7; }
form { margin-top:28px; padding:22px; border:1px solid #e2e8f0; border-radius:16px; background:#fff; }
label { display:block; margin-bottom:8px; color:#475569; font-size:14px; font-weight:700; }
input { width:100%; box-sizing:border-box; min-height:46px; padding:10px 12px; border:1px solid #dbe3ef; border-radius:10px; font-size:16px; }
input:focus { outline:2px solid #bfdbfe; border-color:#60a5fa; }
.error { min-height:20px; margin:8px 0 14px; color:#be123c; font-size:14px; line-height:1.7; }
button { cursor:pointer; }
form button { width:100%; min-height:46px; border:0; border-radius:10px; background:#2563eb; color:#fff; font-size:15px; font-weight:700; }
form button:disabled { opacity:.5; cursor:default; }
.admin-access-bar { max-width:620px; margin:0 auto; padding:12px 10px 0; text-align:right; }
.admin-access-bar button { padding:8px 12px; border:1px solid #e2e8f0; border-radius:8px; background:#f8fafc; color:#475569; font-size:14px; }
button:focus-visible, a:focus-visible { outline:3px solid #93c5fd; outline-offset:3px; }
</style>
